"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_DETAILS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_DETAILS = (0, gql_1.gql)(`
  query ProductDetails(
    $productIds: [ID!],
    $catalog: ID!,
    $baseLabels: [String!],
    $skipMeasures: Boolean!,
  ) {
    products(catalogs: [$catalog], ids: $productIds) {
      edges {
        node {
          ...ProductFragment
          originalAttributions: labels(first: 2000, filters: { origin: { in: [ORIGINAL] } }) {
            edges {
              node {
                label
                status
                origin
                value
              }
            }
          }
          validAttributions: labels(first: 2000, filters: { status: { in: [IN_STRATEGY, VALID] } }) {
            edges {
              node {
                label
                status
                origin
                value
                assertedIncorrect
              }
            }
          }
          # request these fields separately, regardless of their status
          baseAttributions: labels(first: 2000, filters: { label: { in: $baseLabels } }) {
            edges {
              node {
                label
                status
                origin
                value
              }
            }
          }
          measures(first: 2000) @skip (if: $skipMeasures) {
            edges {
              node {
                dimension
                explanation
                origin
                status
                unit
                value
              }
            }
          }
        }
      }
    }
  }
`);
